import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";
import { toast } from "react-hot-toast";

import { RegistroContaReceberDTO } from "types/dto/RegistroContaReceberDTO";
import { PaginatedRequest } from "types/request/PaginatedRequest";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";

type Request = {
  processoJudicialId?: number;
} & PaginatedRequest;

export const useGetCobrancasVinculadasAoProcesso = (request: Request) => {
  const { setProcessoPossuiCobrancasVinculadas } = useProcessosJudiciaisContext();
  const onError = () => {
    toast.error("Erro ao buscar cobranças vinculadas ao processo");
  };

  const onSuccess = (resp: Page<RegistroContaReceberDTO>) => {
    setProcessoPossuiCobrancasVinculadas(resp.totalElements > 0);
  };

  const config = {
    staleTime: 1000 * 60 * 5,
    retry: 5,
  };

  return useFetch<Page<RegistroContaReceberDTO>>({
    key: ["cobrancas-vinculadas-ao-processo", request.processoJudicialId, request.sort, request.page],
    url: api.processosJudiciaisContaReceber.getCobrancasVinculadosAoProcesso,
    params: request,
    enabled: request.processoJudicialId !== undefined,
    config,
    onError,
    onSuccess,
  });
};
